import { TopLevelSpecification } from '../../TopLevelSpecification';
import { LevelSpecification } from '../../LevelSpecification';

export const isTopLevel = (
  levelSpecification: LevelSpecification
): levelSpecification is TopLevelSpecification => levelSpecification.level >= 0;
